import { put } from 'redux-saga/effects';

import { setBalanceAction } from 'core/widgets/User/actions';
import { Notifications } from 'types';
import { OnPlayerWonData } from '../types';
import { setWinStatusAction } from 'core/widgets/WinStatus/actions';

export function* onPlayerWonSaga({ type: notificationType, data: result }: OnPlayerWonData) {
  if (notificationType === Notifications.PLAYER_WON) {
    const {
      player: { balance },
      winner,
      winningAmount,
    } = result;

    yield put(setBalanceAction(balance));
    yield put(setWinStatusAction({ winner, winningAmount }));
  }
}
